const initialClients = {
  clients: [],
  errorMessage: '',
};

export default initialClients;
